import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  const token = auth.getToken();
  const isAiRequest = req.url.startsWith(environment.aiApiUrl);

  // Attach Bearer token for main API only — AI endpoints use x-api-key instead
  const authReq = token && !isAiRequest
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // AI service endpoints use x-api-key, not Bearer — a 401 from them
        // is a server/key issue, not an expired user session. Skip logout.
        if (!isAiRequest) {
          auth.logout();
          router.navigate(['/auth/login']);
        }
      }
      return throwError(() => err);
    })
  );
};
